(function() {

	var expandLink = '.js-expand-link';
	var $expandLink = $(expandLink);
	var expandContent = '.js-expand-content';
	var $expandContent = $(expandContent);

	var params = {
		toggleSpeed: 'fast'
	};

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `expand`
	 *
	 * Shows the content attached to the link.
	 *
	 * @param e (object) - event object
	 */
	function expand(e) {
		e.preventDefault();
		var $trigger = $(this);
		var target_id = $trigger.attr('href');

		$(target_id).slideDown(params.toggleSpeed);
	}

	//  ======================================================================  //
	//  On ready
	//  ======================================================================  //

	onReady.callbacks.expand = function() {
		$expandContent.hide();
	};

	//  ======================================================================  //
	//  On click
	//  ======================================================================  //

	_$document.on('click', expandLink, expand);

})();
